var tag = document.createElement('script');

tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

$(function () {

    $('.videohtml5').each(function (index, element) {
        // element == this        
        
        $(this).find(`.backdrop`).click(function (e) { 
            e.preventDefault();
            $(this).fadeOut();

            $(this).siblings('video').trigger('play');
        });

        $(this).find(`video`).click(function (e) { 
            e.preventDefault();
            $(this).trigger('pause');

            $(this).siblings('.backdrop').fadeIn();
        });
    });
    
    $('.videoyoutube').each(function (index, element) {
        var $this = $(this);
        var YTID = $(this).children('.video').children('iframe').attr('id');
        var player = new YT.Player(YTID, {
            events: {
                    'onStateChange': function(e) {
                        if(e.data === 2 || e.data === 0) {
                            $this.children(`.backdrop`).fadeIn();
                        }
                    }
                }
        });
        

            
        $this.children(`.backdrop`).click(function (e) { 
            e.preventDefault();
            $(this).fadeOut();
            player.playVideo();
        });

    });



});